// extracted by mini-css-extract-plugin
export default {"rating":"qB-z","numberOfStars":"rB-z","count":"sB-z","barGraphSpacing":"tB-z","barGraph":"uB-z"};